import { render, staticRenderFns } from "./ArvoreItens.vue?vue&type=template&id=208ba1ea&scoped=true&"
import script from "./ArvoreItens.vue?vue&type=script&lang=js&"
export * from "./ArvoreItens.vue?vue&type=script&lang=js&"
import style0 from "./ArvoreItens.vue?vue&type=style&index=0&id=208ba1ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208ba1ea",
  null
  
)

export default component.exports